import React from "react";
import BaseDraggable from "./BaseDraggable";
import {} from "lucide-react";

const ShapeComponent = ({
  id,
  position,
  width = 120,
  height = 120,
  shapeType,
  backgroundColor = "#3B82F6",
  borderRadius = 0,
  opacity = 1,
  rotation = 0,
  borderWidth = 0,
  borderColor = "#000000",
  borderStyle = "solid",
  onDelete,
  onUpdate,
  onDoubleClick,
}) => {
  const getShapePath = () => {
    switch (shapeType) {
      case "triangle":
        return `polygon(50% 0%, 0% 100%, 100% 100%)`;
      case "circle":
        // return `circle(50%)`;
        return `ellipse(50% 50% at 50% 50%)`;
      case "pentagon":
        return `polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)`;
      case "hexagon":
        return `polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)`;
      case "star":
        return `polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)`;
      default:
        return null; // rectangle doesn't need a clip-path
    }
  };

  const handleResize = (componentId, dimensions) => {
    onUpdate(id, dimensions);
  };

  return (
    <BaseDraggable
      id={id}
      type="shape"
      position={position}
      className="group"
      onDelete={onDelete}
      onResize={handleResize}
      minWidth={20}
      minHeight={20}
      style={{
        width,
        height,
        background: "transparent", // Make BaseDraggable background transparent
        border: "none", // Remove default border
        boxShadow: "none", // Remove default shadow
      }}
    >
      <div
        className="w-full h-full"
        onDoubleClick={(e) => onDoubleClick?.("shape", id, e)}
        style={{ background: "transparent" }} // Ensure container is also transparent
      >
        <div
          className="w-full h-full"
          style={{
            backgroundColor,
            opacity,
            width: "99%",
            height: "99%",
            margin: "auto",
            // borderRadius:
            //   shapeType === "rectangle"
            //     ? borderRadius
            //     : shapeType === "circle"
            //     ? "100%"
            //     : 0,
            borderRadius: shapeType === "rectangle" ? `${borderRadius}px` : 0,
            clipPath: getShapePath(),
            transform: `rotate(${rotation}deg)`,
            border: `${borderWidth}px ${borderStyle} ${borderColor}`,
            transition: "all 0.2s ease",
          }}
        />
      </div>
    </BaseDraggable>
  );
};

export default ShapeComponent;
